const buildTransactionId = id => {
  if (!id) return '';

  const [snippet] = id.split('-');
  return `${snippet}-${Date.now()}`;
};

export default buildTransactionId;
